module.exports = __webpack_public_path__ + "img/cfr-cluj.e6b51b54.png";